import { render, staticRenderFns } from "./SubMenuItem.vue?vue&type=template&id=680d14d2&scoped=true&"
import script from "./SubMenuItem.vue?vue&type=script&lang=js&"
export * from "./SubMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./SubMenuItem.vue?vue&type=style&index=0&id=680d14d2&lang=scss&scoped=true&"
import style1 from "./SubMenuItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680d14d2",
  null
  
)

export default component.exports